import * as React from "react";

import "./search-options-mobile.scss";
import "./search-options-desktop.scss";

import {Responsive}     from "../../../../../apmui/src/common/layout/responsive";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {Select2}        from "@Common/ui-components/select-2/select-2";

import {EmulationModal}      from "../../common/emulation-modal/emulation-modal";
import {showOfficeEmulation} from "../../common/logic/show-office-emulation";

import {SearchBox}        from "./search-box/search-box";
import {SortingDirection} from "./sorting-direction/sorting-direction";
import {ViewType}         from "./view-type/view-type";

export const SearchOptions = ({filterInitValue="", isCC=false, next}) => cs(

    ["filter", (_, next) => UseState({initValue: filterInitValue, next})],
    ["sorting", (_, next) => UseState({next})],
    ["viewType", (_, next) => UseState({initValue: "list",next})],

    ({filter, sorting, viewType}) => next({
        options: {
            filter: filter.value,
            sorting: sorting.value,
        },
        viewType: viewType.value,
        render: ({totalCount}) => cs(

            ["emulationModal", (_, next) => cs(
                consumeContext("userLevels"),
                ({userLevels}) => (userLevels?.userLevel === 3 || userLevels?.userLevel === 4) ? EmulationModal({next}) : next(),
            )],
            // @ts-ignore
            ["responsive", (_, next) => <Responsive {...{
                sizes: {
                    md: 1024,
                },
                next,
            }}/>],
            ({responsive, emulationModal}) => (responsive.lt("md") || isCC ? MobileMode : DesktopMode)({
                filter,
                filterInitValue,
                totalCount,
                sorting,
                viewType,
                showEmulationModal: emulationModal && !isCC && (() => emulationModal.show()),
            }),
        ),
    }),
);

const MobileMode = ({filter, filterInitValue, sorting, totalCount, viewType, showEmulationModal}) => cs(
    consumeContext("userLevels"),
    consumeContext("themeScheme"),
    ({userLevels, themeScheme}) => (
        <div className="search-options-7w1 mobile">
            <div className="filter">
                {SearchBox({filter, initValue: filterInitValue})}
            </div>

            <div className="line2">
                <div className="left">
                    <div className="count">
                        {totalCount ?? "--"} Results
                    </div>
                    {showEmulationModal && (
                        <a 
                            className="link" 
                            onClick={showEmulationModal} 
                            xd-qa-type="link" 
                            xd-qa-name="Selection"
                        >
                            {showOfficeEmulation(userLevels) ? (
                                "Select Office & User"
                            ) : (
                                "Select User"
                            )}
                        </a>
                    )}
                </div>
                <div className="right">
                    <div className="sorting">
                        {SortingSelect({sorting})}

                        {SortingDirection({sorting, iconColor: themeScheme.xpresso.menuBackgroundColorShadow})}
                    </div>
                </div>
            </div>
        </div>
    )
);

const DesktopMode = ({filter, filterInitValue, sorting, viewType, showEmulationModal}) => cs(
    consumeContext("userLevels"),
    consumeContext("themeScheme"),
    ({userLevels, themeScheme}) => (
        <div className="search-options-7w1 desktop">
            <div className="left">
                {SearchBox({filter, initValue: filterInitValue})}

                {showEmulationModal && (
                    <a
                        className="link"
                        onClick={showEmulationModal}
                        xd-qa-type="link"
                        xd-qa-name="Selection"
                    >
                        {showOfficeEmulation(userLevels) ? (
                            "Select Office & User"
                        ) : (
                            "Select User"
                        )}
                    </a>
                )}
            </div>

            <div className="space"/>

            <div className="right">
                {ViewType({viewType})}

                <div className="sorting">
                    {SortingSelect({sorting})}

                    {SortingDirection({sorting, iconColor: themeScheme.xpresso.menuBackgroundColorShadow})}
                </div>
            </div>

        </div>
    ),
);

const SortingSelect = ({sorting}) => Select2({
    className: "sorting-select",
    list: [
        {
            label: "Street Address",
            value: "streetAddress",
            direction: "asc",
        },
        {
            label: "City",
            value: "city",
            direction: "asc",
        },
        {
            label: "Zip Code",
            value: "zip",
            direction: "asc",
        },
        {
            label: "MLS/Listing ID",
            value: "mlsId",
            direction: "asc",
        },
        {
            label: "Date Listed",
            value: "dateListed",
            direction: "desc",
        },
        {
            label: "Date Sold",
            value: "dateSold",
            direction: "desc",
        },
        {
            label: "Price",
            value: "listedPrice",
            direction: "asc",
        },
    ],
    getLabel: (i) => i.label,
    placeholder: "Sort by...",
    onSelect: (i) => sorting.onChange(i && {
        direction: i.direction,
        value: i.value,
    }),
    isSelected: (i) => i.value === sorting.value?.value,
    "xd-qa-type":"dropdown",
    xdQaName:"sort",
});
